import React from 'react';

interface ProgressBarProps {
  progress: number;
  height?: string;
  bgColor?: string;
  progressColor?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  height = 'h-2.5',
  bgColor = 'bg-blue-100',
  progressColor = 'bg-blue-600',
}) => {
  return (
    <div className={`w-full ${bgColor} rounded-full ${height}`}>
      <div
        className={`${progressColor} ${height} rounded-full`}
        style={{ width: `${progress * 100}%` }}
      />
    </div>
  );
};
